<template>
  <div class="error-page" v-loading="loading === 'true'">
    <div>
      <em class="el-icon-warning"></em>
      <span>服务异常！！！请联系管理员</span>
    </div>
    <el-button @click="goHome">返回主页</el-button>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      validator() {
        return true;
      },
      default: 'false'
    }
  },
  methods: {
    goHome() {
      if (this.loading === 'true') return;
      this.$router.push({ params: { loading: true } });
      this.pushToHomePage();
    }
  }
};
</script>

<style lang="scss">
.error-page {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $normal-color;
  font-size: 36px;
  em,
  span {
    padding: 10px 0;
  }
}
</style>
